import * as React from "react";
import * as ReactRedux from "react-redux";
import {Route} from "react-router-dom";

import TextField from "material-ui/TextField";
import {Tabs, Tab} from "material-ui/Tabs";
import RaisedButton from "material-ui/RaisedButton";

import {selectors, actions} from "../../reducers/current_user";
const gears = require("../../res/loading.svg");
const icon = require("../../res/avatar_default.png");

const mapStateToProps = state => ({
	isRegistering: selectors.selectIsRegistering(state),
});

const mapDispatchToProps = {
	register: actions.register,
};

interface RegisterStepProps {
	goToStep: (step: string) => void;
	registerStatus: string;
	isRegistering: boolean;
	register: (firstName: string,
			   lastName: string,
			   email: string,
			   password: string) => any;
}

class RegisterStepComponent extends React.Component<RegisterStepProps, any> {
	state = {
		firstName: "",
		lastName: "",
		password: "",
		email: ""
	};

	onChangeFirstName(e) {
		this.setState({firstName: e.target.value});
	}

	onChangeLastName(e) {
		this.setState({lastName: e.target.value});
	}

	onChangePassword(e) {
		this.setState({password: e.target.value});
	}

	onChangeEmail(e) {
		this.setState({email: e.target.value});
	}

	componentWillReceiveProps(props) {
		if (props.errorMessage !== "") {
			this.setState({errorVisible: true});
		}

		this.setState({errorMessage: props.errorMessage});
	}

	register() {
		this.setState({isRegistering: true});
		this.props.register(
			this.state.email,
			this.state.firstName,
			this.state.lastName,
			this.state.password);
	}

	render() {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
					alignItems: "center",
					marginTop: "2rem",
					position: "relative",
					right: 0,
					width: 440,
					borderRadius: 3,
				}}
			>
				{/* note: i am removing the back button because login is now a single-step */}

				<Route render={({ history}) => (
					<img
						src={require("../../res/chevron-left.svg")}
						onClick={() => { history.goBack() }}
						style={{
						position: "absolute",
						top: 25,
						left: 25,
						cursor: "pointer",
					}}
					/>
				)}/>

				<img
					style={{
						maxWidth: 75,
						width: "100%",
						marginBottom: "1rem",
					}}
					src={this.props.isRegistering? gears : icon}
				/>

				<form
					onSubmit={e => {
						e.preventDefault();
						this.register.apply(this);
					}}
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "space-between",
						flex: 1,
					}}
				>
					<TextField
						floatingLabelText="First Name"
						type="text"
						value={this.state.firstName}
						onChange={this.onChangeFirstName.bind(this)}
						autoFocus
						required
					/>
					<TextField
						floatingLabelText="Last Name"
						type="text"
						value={this.state.lastName}
						onChange={this.onChangeLastName.bind(this)}
						required
					/>

					<TextField
						floatingLabelText="Email"
						type="email"
						value={this.state.email}
						onChange={this.onChangeEmail.bind(this)}
						required
					/>

					<TextField
						floatingLabelText="Password"
						type="password"
						value={this.state.password}
						onChange={this.onChangePassword.bind(this)}
						style={{
							marginBottom: "2rem",
						}}
						required
					/>
					<RaisedButton
						style={{width:"100%"}}
						label="Register"
						type="submit"
						disabled={this.props.isRegistering}
					/>

				</form>
			</div>
		);
	}
}

export default ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(RegisterStepComponent);



// WEBPACK FOOTER //
// ./src/components/login/register.tsx